import { request, getApiUrl } from '@/utils/ajax';
import { CatalogGroup, Project, OptionalId, ProjectTag } from '@/types';

export function saveCatalogGroup(group: OptionalId<CatalogGroup>, productIds: number[] | null): Promise<CatalogGroup> {
    return request(`api/profile-catalog-group`, {
        method: 'POST',
        json: true,
        body: {
            group,
            productIds,
        },
    }).then((x) => x.json());
}

interface LinkedProductOptions {
    catalogProductId: number;
    price: number;
}

interface LinkCatalogGroupRequest {
    groupId: number;
    residentialUnitIds: number[];
    productOptions: LinkedProductOptions[];
    deadlineId: number;
    pricingFieldId: number | null;
    name: string;
    projectTags: OptionalId<ProjectTag>[];
    description: string;
    providedByProfileId: number | null;
    projectFeeSetId: number;
    defaultProductId: number | null;
    showQuantityToBuyers: boolean;
}

export function linkCatalogGroup(data: LinkCatalogGroupRequest) {
    return request(`api/profile-catalog-group/${data.groupId}/link`, {
        method: 'POST',
        json: true,
        body: data,
    });
}

interface SearchCatalogGroupsOptions {
    searchText?: string;
    floorPlanSketchTypeId?: number | null;
    ownerProfileId?: number;
    itemCategoryIds?: number[];
}

export function searchCatalogGroups(options: SearchCatalogGroupsOptions): Promise<CatalogGroup[]> {
    return request(`api/profile-catalog-group`, {
        query: options,
    }).then((x) => x.json());
}

export function getCatalogGroupsByOwner(profileId: number): Promise<CatalogGroup[]> {
    return request(`api/profile-catalog-group`, {
        query: {
            ownerProfileId: profileId,
        },
    }).then((x) => x.json());
}

export function getCatalogGroup(groupId: number): Promise<CatalogGroup> {
    return request(`api/profile-catalog-group/${groupId}`).then((x) => x.json());
}

// export function getCatalogGroupLinkedProjects(groupId: number): Promise<Project> {
//     return request(`api/catalog-group/${groupId}/linked-projects`).then((x) => x.json());
// }

export function getCatalogGroupThumbnailUrl(groupId: number): string {
    return getApiUrl() + `/api/profile-catalog-group/${groupId}/thumbnail`;
}

export function deleteCatalogGroup(groupId: number) {
    return request(`api/profile-catalog-group/${groupId}`, {
        method: 'DELETE',
    });
}
export function editCatalogGroup(group: CatalogGroup) {
    return request(`api/profile-catalog-group/`, {
        method: 'PUT',
        json: true,
        body: {
            group,
        },
    });
}

export function getLinkableProjects(groupId: number): Promise<Project[]> {
    return request(`api/profile-catalog-group/${groupId}/linkable-projects`).then((x) => x.json());
}
